import { useMutation } from "@tanstack/react-query";
import AIToolsAPI from "../../api/AIToolsAPI";

export interface CustomPromptPayload {
  description: string;
  instructions?: string;
}

/**
 * Used to generate text with ChatGPT or Nasser's endpoints
 */
const useCustomPrompt = () => {
  const generateText = useMutation({
    mutationFn: ({
      payload,
      onSuccess,
    }: {
      payload: CustomPromptPayload;
      onSuccess: (text: string) => void;
    }) =>
      AIToolsAPI.generateText(payload).then((data) => {
        onSuccess(data.data.data.text);
      }),
  });

  return {
    generateText: generateText.mutate,
    generating: generateText.isPending,
    generateError: generateText.error,
  };
};

export default useCustomPrompt;
